"use strict";

const IncidentsFilters = function () {
  const searchFields = ["incidentName"];
  const searchDbFields = ["incident_name"];

  var filterResourceDataHandler = function (unfilteredData, filters, loadingScreen, smartFilters) {
    const filteredData = ResourceFilters.spatialFilters(unfilteredData, filters);
    return filterOffline(filteredData, filters, smartFilters);
  };

  var filterOffline = function (unfilteredData, filters, smartFilters) {
    if (DataViewFunctions.getCurrentDataViewProperty("smartToDoFilters") || !filters?.toDoFilters) {
      return smartFilters ? smartFilters.filter(unfilteredData, filters) : unfilteredData;
    } else {
      return unfilteredData.filter((datum) => {
        return ResourceFilters.passToDoFilters(datum, filters);
      });
    }
  };

  var passRequestedDateFilter = function (datum, filters) {
    return ResourceFilters.passIsoDateFilter(
      datum.requestedDate,
      filters.requestedDate?.from,
      filters.requestedDate?.to,
    );
  };

  var addGeoServerFilterQuery = function (queryStrings, filters) {
    if (filters.searchString) {
      queryStrings.push(
        GeoServerFilterFunctions.getSearchQuery(searchDbFields, filters.searchString),
      );
    }
    GeoServerFilterFunctions.addGeographicalFocusFiltersToQuery(filters, queryStrings, [
      { key: "drainsToRw", field: "drains_to_rw" },
      { key: "drainsToC", field: "drains_to_c" },
      { key: "catchmentName", field: "catchment_name" },
    ]);
    GeoServerFilterFunctions.addFilterToGeoServerQuery(
      queryStrings,
      filters,
      "closeOutReason",
      "close_out_reason",
    );
    GeoServerFilterFunctions.addFilterToGeoServerQuery(
      queryStrings,
      filters,
      "incidentType",
      "incident_type",
    );
    GeoServerFilterFunctions.addFilterToGeoServerQuery(
      queryStrings,
      filters,
      "incidentStatus",
      "incident_status",
    );
    if (filters.requestedDate) {
      GeoServerFilterFunctions.addDateQuery(
        queryStrings,
        "requested_date",
        filters.requestedDate?.from,
        filters.requestedDate?.to,
      );
    }
    if (
      filters.openEnforcements?.length &&
      !SmartFilterRegistry.getSummary()?.areAllCheckboxesChecked("openEnforcements")
    ) {
      GeoServerFilterFunctions.yesNoNullGeoServerFilter(
        filters,
        "openEnforcements",
        queryStrings,
        "open_enforcements",
      );
    }
  };

  var getFilterConfigs = function () {
    return {
      activityType: ["activityType", "array"],
      drainsToRw: "drainsToRw",
      drainsToC: "drainsToC",
      catchmentName: "catchmentName",
      incidentType: "incidentType",
      incidentStatus: "incidentStatus",
      closeOutReason: "closeOutReason",
      subGroups: "groupId",
      openEnforcements: "openEnforcements",
      ...ResourceFilters.getSmartToDoFilters(),
      otherFilters: (datum, filters) => {
        return (
          ResourceFilters.passSearchStringFilter(datum, filters, searchFields) &&
          passRequestedDateFilter(datum, filters)
        );
      },
    };
  };

  var addGeoServerViewParams = function (params, filters) {
    if (
      filters.activityType?.length &&
      !SmartFilterRegistry.getSummary()?.areAllCheckboxesChecked("activityType")
    ) {
      const jsonPaths = filters.activityType.map((value) => `@ == "${value}"`);
      params.activityTypes = jsonPaths.join(" || ");
    }
  };

  return {
    filterOffline,
    filterResourceDataHandler,
    addGeoServerFilterQuery,
    addGeoServerViewParams,
    getFilterConfigs,
  };
};

module.exports = IncidentsFilters();

const DataViewFunctions = require("../../dataViewFunctions");
const GeoServerFilterFunctions = require("../../mapFunctions/geoServerFilterFunctions");
const ResourceFilters = require("../../filters/resourceFilters");
const SmartFilterRegistry = require("../../filters/smartFilterRegistry");
